import { get, ref } from "firebase/database";
import { db, auth } from "../services/firebase";

/**
 * One-time status checker for any interview test.
 * Returns the status object if exists (or null if not).
 */
export default async function checkTestStatus(domainId, packId, interviewId) {
    const user = auth.currentUser;
    if (!user) return null;

    const statusRef = ref(db, `Tests/Status/${user.uid}/${domainId}/${packId}/${interviewId}`);
    const snap = await get(statusRef);
    if (snap.exists()) return snap.val();
    return null;
}
